<template>
    <div class=" py-12 gradient-light-radial">
        <div class="flex flex-col gap-3 justify-between items-center text-3xl font-headings mx-auto max-w-xl">
            <div>Ready to dive in?</div>
            <a href='/signup' class="inline-flex"><Button text="Sign up now for a free account" variant="accent" hasArrow size="md" /></a>
            <div class="text-center text-lg">or <a href='/contact' class="inline-flex text-secondary-600">talk to our team</a> to learn more
            </div>
        </div>
    </div>
</template>

<script setup>
import Button from '../Buttons/Button.vue';
</script>